import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export default noPortalApiClient;